/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMap = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.553 21.896a1 1 0 0 0 .943-.026l6-4A1 1 0 0 0 22 17V3a1 1 0 0 0-1.496-.868l-5.535 3.735-5.522-3.76a1 1 0 0 0-.943.025l-6 4A1 1 0 0 0 2 7.001v14a1 1 0 0 0 1.496.869l5.535-3.735zM8 4.84v11.643l-4 2.794V7.582zm2-.046 4 2.724v11.689l-4-2.724zm10-.07V16.42l-4 2.739V7.517z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMap as Map };
